<app-title-section></app-title-section>

<div class="card p-1"  style="margin-left: 15px; margin-right: 15px; min-height:100vh;">

    <div class="facture-tabs-row">
        <ul class="nav nav-tabs m-0 facture-status-tabs">
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/facture/tous']" [class.active]="currentStatus === 'tous'" (click)="filterByStatus('tous')">
                    Tous <app-tab-count [count]="getStatusCount('Tous')"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/facture/brouillon']" [class.active]="currentStatus === 'brouillon'" (click)="filterByStatus('brouillon')">
                    Brouillon <app-tab-count [count]="getStatusCount('Brouillon')"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/facture/paye']" [class.active]="currentStatus === 'paye'" (click)="filterByStatus('paye')">
                    Payé <app-tab-count [count]="getStatusCount('Payé')"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/facture/non_payé']" [class.active]="currentStatus === 'non_payé'" (click)="filterByStatus('non_payé')">
                    Non Payé <app-tab-count [count]="getStatusCount('Non payé')"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/facture/annule']" [class.active]="currentStatus === 'annule'" (click)="filterByStatus('annule')">
                    Annulé <app-tab-count [count]="getStatusCount('Annulé')"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/facture/part-paye']" [class.active]="currentStatus === 'partPaye'" (click)="filterByStatus('partPaye')">
                    Partiellement payé <app-tab-count [count]="getStatusCount('Partiellement payé')"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/facture/consolidation']" [class.active]="currentStatus === 'consolidation'" (click)="filterByStatus('consolidation')">
                    Consolidation <app-tab-count [count]="getStatusCount('Consolidation')"></app-tab-count>
                </a>
            </li>
        </ul>
        <button type="button"
                class="facture-display-settings-btn"
                (click)="openDisplaySettings()"
                title="Paramètres d'affichage"
                aria-label="Paramètres d'affichage">
            <i class="bi bi-gear" aria-hidden="true"></i>
        </button>
    </div>

    <div class="container-fluid" style="padding: 0; width: 100%; max-width: 100%;">
        <router-outlet></router-outlet>
    </div>
</div>

<!-- Panneau (même principe que Paramètres document sur edit-facture) -->
<div class="settings-overlay" [class.active]="isDisplaySettingsOpen" (click)="closeDisplaySettings()"></div>
<div class="settings-panel" [class.active]="isDisplaySettingsOpen">
    <div class="settings-header">
        <h3>Paramètres d'affichage</h3>
        <button type="button" class="close-btn" (click)="closeDisplaySettings()" aria-label="Fermer">
            <i class="bi bi-x-lg"></i>
        </button>
    </div>
    <div class="tab-content">
        <div class="form-group">
            <label>Afficher les champs du tableau</label>
            <div class="checkbox-group-doc">
                <label class="container" *ngFor="let field of displayFields">
                    <input type="checkbox"
                           [(ngModel)]="displayDraft[field.key]"
                           (ngModelChange)="onDisplayFieldChange()">
                    <span class="checkmark"></span>
                    <span>{{ field.label }}</span>
                </label>
            </div>
        </div>
        <button type="button"
                class="btn save-btn text-white"
                (click)="saveDisplaySettings()">
            Enregistrer
        </button>
    </div>
</div>
